module.exports = __webpack_public_path__ + "static/img/wheel-pointer.0901fa5c.png";